"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var label_1 = require("../label");
exports.default = (function (_a) {
    var className = _a.className, theme = _a.theme, label = _a.label, red = _a.red, blue = _a.blue, green = _a.green, orange = _a.orange, yellow = _a.yellow, black = _a.black, blink = _a.blink, _b = _a.uppercase, uppercase = _b === void 0 ? true : _b, others = tslib_1.__rest(_a, ["className", "theme", "label", "red", "blue", "green", "orange", "yellow", "black", "blink", "uppercase"]);
    var _c;
    return (React.createElement("div", { className: classnames_1.default(theme.attention, className, (_c = {},
            _c[theme.blue] = blue || (!red && !green && !orange && !yellow && !black),
            _c[theme.red] = red,
            _c[theme.green] = green,
            _c[theme.orange] = orange,
            _c[theme.yellow] = yellow,
            _c[theme.black] = black,
            _c[theme.blink] = !!blink,
            _c)) },
        React.createElement("div", { className: theme.dot, style: { animationDuration: blink + "s" } }),
        React.createElement(label_1.Label, { weight: "bold", uppercase: uppercase, size: 12, spacing: 1, nunito: true }, label)));
});
